"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const inside = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
const href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
const punctuation = '!"#$%&\'()*+,\\-./:;<=>?@\\[^_{|}~';
function edit(regex, opt) {
    let newRegex = regex.source || regex;
    opt = opt || '';
    return {
        replace: function replaceRegex(name, val) {
            var _a;
            let newVal = (_a = val.source) !== null && _a !== void 0 ? _a : val;
            newVal = newVal.replace(/(^|[^\[])\^/g, '$1');
            newRegex = newRegex.replace(name, newVal);
            return this;
        },
        getRegex: function getRegex() {
            return new RegExp(newRegex, opt);
        }
    };
}
const inline = {
    escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
    autolink: /^<([^ <>]+(@|:\/)[^ <>]+)>/,
    url: /^(https?:\/\/[^\s<>]+[^<>.,:;"')\]\s])/,
    tag: [/^<!--[\s\S]*?-->/i, /^<\/?\w+(?:"[^"]*"|'[^']*'|[^'"<>])*?> *\n?/],
    mdlink: (0, utils_1.replace)(/^!?\[(inside)\]\(href\)/i)('inside', inside)('href', href)(),
    anchorlink: /^ *\<a(?<attributes> [^<>]*)\>(?<content>[\s\S]+?)\<\/a(?: [^<>]*)?\>\n?/i,
    reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
    nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
    strong: [
        /^__([\s\S]+?)__(?!_)/i,
        /^\*\*([\s\S]+?)\*\*(?!\*)/i,
        /^ *\<b(?: [\s\S]*?)?\>([\s\S]+?)\<\/b(?: [\s]*)?\>\n?/i,
        /^ *\<strong(?: [\s\S]*?)?\>([\s\S]+?)\<\/strong(?: [\s]*)?\>\n?/i
    ],
    em: [
        /^\b_((?:[^_]|__)+?)_\b/i,
        /^\*((?:\*\*|[\s\S])+?)\*(?!\*)/i,
        /^_([^\s_])(?!_)_|^\*([^\s*"<\[])\*(?!\*)/,
        edit(/^_([^\s][\s\S]*?[^\s_])_(?!_|[^\spunctuation])/)
            .replace(/punctuation/g, punctuation)
            .getRegex(),
        edit(/^_([^\s_][\s\S]*?[^\s])_(?!_|[^\spunctuation])/)
            .replace(/punctuation/g, punctuation)
            .getRegex(),
        /^\*([^\s"<\[][\s\S]*?[^\s*])\*(?!\*)/,
        /^\*([^\s*"<\[][\s\S]*?[^\s])\*(?!\*)/,
        /^ *\<i(?: [\s\S]*?)?\>([\s\S]+?)\<\/i(?: [\s]*)?\>\n?/i,
        /^ *\<em(?: [\s\S]*?)?\>([\s\S]+?)\<\/em(?: [\s]*)?\>\n?/i
    ],
    code: [
        /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/i,
        /^ *\<code(?: [\s\S]*?)?\>([\s\S]+?)\<\/code(?: [\s]*)?\>\n?/i
    ],
    br: /^ {2,}\n(?!\s*$)/,
    del: [
        /^~~(?=\S)([\s\S]*?\S)~~/i,
        /^ *\<s(?: [\s\S]*?)?\>([\s\S]+?)\<\/s(?: [\s]*)?\>\n?/i,
        /^ *\<del(?: [\s\S]*?)?\>([\s\S]+?)\<\/del(?: [\s]*)?\>\n?/i,
        /^ *\<strike(?: [\s\S]*?)?\>([\s\S]+?)\<\/strike(?: [\s]*)?\>\n?/i
    ],
    text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
};
inline.reflink = (0, utils_1.replace)(inline.reflink)('inside', inside)();
inline.escape = (0, utils_1.replace)(inline.escape)('])', '~|])')();
inline.text = (0, utils_1.replace)(inline.text)(']|', '~]|')('|', '|https?://|')();
// line breaks
inline.br = (0, utils_1.replace)(inline.br)('{2,}', '*')();
inline.text = (0, utils_1.replace)(inline.text)('{2,}', '*')();
const inlineGrammar = Object.keys(inline).reduce((accum, key) => {
    const current = inline[key];
    if (Array.isArray(current)) {
        accum[key] = {
            source: current,
            exec: (src) => {
                let index = 0;
                while (current[index]) {
                    const result = current[index].exec(src);
                    if (result) {
                        result.decomposed = {
                            [index]: result
                        };
                        return result;
                    }
                    index += 1;
                }
                return null;
            }
        };
    }
    else {
        accum[key] = current;
    }
    return accum;
}, {});
exports.default = inlineGrammar;
